// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3BoOn","header":"ClearentDisclaimer_header__3grSB","inner":"ClearentDisclaimer_inner__1INM5"};